import {
  TEST_RUNS_FETCH_REQUEST,
  TEST_RUNS_FETCH_SUCCESS,
  TEST_RUNS_FETCH_FAILURE,
  TEST_RUN_FETCH_REQUEST,
  TEST_RUN_FETCH_SUCCESS,
  TEST_RUN_FETCH_FAILURE,
  TEST_RUN_CLEANUP_REQUEST,
  TEST_RUN_CLEANUP_SUCCESS,
  TEST_RUN_CLEANUP_FAILURE,
  TEST_SPEED_FETCH_SUCCESS,
  TEST_SPEED_UPDATE_SUCCESS,
  TEST_PROGRAMS_FETCH_SUCCESS,
} from '../../types';
import {
  getTestRunsApi,
  getTestRunApi,
  cleanupTestProgramApi,
  getTestSpeedApi,
  setTestSpeedApi,
  getTestProgramsApi,
} from '../../api/testManagement';

export const fetchTestRuns = () => async (dispatch: any) => {
  dispatch({ type: TEST_RUNS_FETCH_REQUEST });
  try {
    const response = await getTestRunsApi();
    dispatch({ type: TEST_RUNS_FETCH_SUCCESS, payload: response.data });
  } catch (error) {
    const err = error as any;
    dispatch({
      type: TEST_RUNS_FETCH_FAILURE,
      payload: err?.response?.data?.message || 'Failed to fetch test runs',
    });
  }
};

export const fetchTestRun = (id: string) => async (dispatch: any) => {
  dispatch({ type: TEST_RUN_FETCH_REQUEST });
  try {
    const response = await getTestRunApi(id);
    dispatch({ type: TEST_RUN_FETCH_SUCCESS, payload: response.data });
  } catch (error) {
    const err = error as any;
    dispatch({
      type: TEST_RUN_FETCH_FAILURE,
      payload: err?.response?.data?.message || 'Failed to fetch test run',
    });
  }
};

export const cleanupTestProgram = (programId: string, runId?: string) => async (dispatch: any) => {
  dispatch({ type: TEST_RUN_CLEANUP_REQUEST });
  try {
    await cleanupTestProgramApi(programId, runId);
    dispatch({ type: TEST_RUN_CLEANUP_SUCCESS, payload: { programId, runId } });
    // Refresh the list
    dispatch(fetchTestRuns());
  } catch (error) {
    const err = error as any;
    dispatch({
      type: TEST_RUN_CLEANUP_FAILURE,
      payload: err?.response?.data?.message || 'Cleanup failed',
    });
  }
};

export const fetchTestSpeed = () => async (dispatch: any) => {
  try {
    const response = await getTestSpeedApi();
    dispatch({ type: TEST_SPEED_FETCH_SUCCESS, payload: response.data });
  } catch {
    // Ignore
  }
};

export const updateTestSpeed = (speedMultiplier: number) => async (dispatch: any) => {
  try {
    const response = await setTestSpeedApi(speedMultiplier);
    dispatch({ type: TEST_SPEED_UPDATE_SUCCESS, payload: response.data });
  } catch {
    // Ignore
  }
};

export const fetchTestPrograms = () => async (dispatch: any) => {
  try {
    const response = await getTestProgramsApi();
    dispatch({ type: TEST_PROGRAMS_FETCH_SUCCESS, payload: response.data });
  } catch {
    // Ignore
  }
};
